export default function Jet() {
  return (
    <div
      className="ion-icon-jet"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<style type="text/css">
<![CDATA[
	.st0{fill:#010101;}
]]>
</style>
<path class="st0" d="M314.8,368.5L419,403l-3-52.7L302,247c0,0-25.9-173.7-28.2-192.3C268.5,14.4,255.9,0,255.9,0
	s-12.5,14.4-17.6,54.6C235.9,73.3,210,247,210,247L96,350.3L93,403l104.2-34.5l1.4,12.3l-52.7,58.3l18.3,27.4l73.3-9.1l18.3,54.6
	l18.5-54.6l73.4,9.1l18.3-27.4l-52.7-58.3L314.8,368.5z"/>
</svg>
`,
      }}
    />
  )
}
